//@ts-check
import React from 'react';
/**
 * @param {import('form/field/types').FormFieldAutoComplete} autoComplete
 */

var getAutoComplete = function getAutoComplete(autoComplete) {
  var inputProps = {};
  var dataList = null;

  if (typeof autoComplete === 'object') {
    inputProps.list = autoComplete.list;
    dataList = React.createElement("datalist", {
      id: autoComplete.list
    }, autoComplete.values.map(function (v) {
      return React.createElement("option", {
        key: v,
        value: v
      });
    }));
  } else if (typeof autoComplete === 'string') {
    inputProps.autoComplete = autoComplete;
  } else if (typeof autoComplete === 'boolean') {
    inputProps.autoComplete = autoComplete ? 'on' : 'off';
  }

  return {
    inputProps: inputProps,
    dataList: dataList
  };
};

export default getAutoComplete;